<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
  </div>
  <div v-if="!data" class="ui active centered inline loader"></div>
  <div v-if="data" class="ui center aligned padding grid">
    <div class="row">
    </div>
    <h4 class="ui horizontal divider header">
      <i class="bar chart icon"></i>
      Evolución mensual
    </h4>
    <trend :data=monthPicks :gradient="['#6fa8dc', '#42b983', '#2c3e50']" auto-draw smooth>
    </trend>
    <div class="row">
      <div class="ui celled horizontal list" v-for="pick in hilabeteZerrenda" v-bind:key="pick.id">
        <div class="item">
          <div class="content">
            <div class="header hilabetea"><b>{{pick.hilabetea}}</b></div>
            <b class="max">{{pick.kop}}</b>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header">
      <i class="database icon"></i>
        Datos de hapiick
    </h4>
    <div class="row">
      <div class="ui statistics">
        <div class="ui statistic">
          <div class="value">
            <img class="ui inline image" src="../assets/apm.png">{{data.apmkop}}
          </div>
          <div class="label">TAQUILLAS ACTIVAS</div>
        </div>
        <div class="ui  statistic">
          <div class="value">
            <i class="users icon"></i> {{data.users}}
          </div>
          <div class="label">Usuarios Registrados</div>
        </div>
        <div class="ui  statistic">
          <div class="value">
            <img class="ui inline image" src="../assets/parcels.png" > {{data.todayPicks}}
          </div>
          <div class="label">Recogidas Hoy</div>
        </div>
        <div class="ui huge horizontal statistic">
          <div class="value">
            {{lastMonthPicks}}
          </div>
          <div class="label">PAQUETES RECOGIDOS EN <H1>{{hilabetea}}</H1></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'Dashboard',
  data() {
    return {
      data: null,
      hilabeteZerrenda: [],
      hilabetea: null,
      lastMonthPicks:null,
      monthPicks: []
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if(role === 'master' || role === 'admin'){
        this.getDashboard()
    } else if (role === 'sabico' || role === 'cau') {
      this.$router.replace('/troubleshooting')
    } else if (role === 'inboxUser' || role === 'inboxAdmin'){
      this.$router.replace('/inbox/parcels')
    } else if (role === 'localUser' || role === 'localAdmin'){
      this.$router.replace('/local/parcels')
    } else if (role === 'hmyCorporate'){
      this.$router.replace('/corporations')
    } else if (role === 'courier'|| role === 'clientApi' || (role.includes('apiclient'))){
      this.$router.replace('/parcels_v2')
    } else if (role === 'shophapiickPoint'){
      this.$router.replace('/history')
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    getDashboard() {
      hapiickApi().post('/v2/stats/dashboard', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(request => this.generateDashboard(request))
      .catch((request) => console.log('error getting dashboard: ' + request))
    },
    generateDashboard(req) {
      this.data = JSON.parse(JSON.stringify(req.data.data))
      var month = new Array()
      let d = new Date()
      let current_year = d.getFullYear();
      let current_month = d.getMonth();
      this.hilabetea = this.$months[current_month]
      let zerrenda = []
      let y = current_year - 1;
      let m = current_month;
      let kop = 0;
      let coors = [];
      let i = 0;
      let datuak = {...this.data.monthPicks};
      
      //tabla
      while (zerrenda.length <= 12) {
        kop = (datuak.hasOwnProperty(y) && datuak[y].hasOwnProperty(m+1)) ? datuak[y][m+1] : 0;
        zerrenda.push({
          'id': i,
          'hilabetea': this.$months[m],
          'kop': kop
        })
        
        i += 1;
        if (i > 12) {
          this.lastMonthPicks = kop;
        }
        m += 1;
        if (m == 12) {
          m = 0;
          y += 1; 
        }
      }

      //Grafico
      y = Math.min(...Object.keys(datuak));
      m = Math.min(...Object.keys(datuak[y]));
      while (y <= current_year) {
        while((y < current_year && m < 12) || (y === current_year && m < current_month)){
          coors.push((datuak.hasOwnProperty(y) && datuak[y].hasOwnProperty(m+1)) ? datuak[y][m+1] : 0);
          i++;
          m++;
        }
        y++;
        m = 0;
      }
      
      this.monthPicks = coors;
      this.hilabeteZerrenda = zerrenda;
    }
  }
}
</script>
<style scoped>
.hilabetea {
  font-size: 12px;
}
.max {
  font-size: 16px;
  color: var(--var-color);
}
.reload:hover {
  -webkit-transform: rotate(1400deg);
  -webkit-transition: -webkit-transform 2s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue